import { createSlice } from "@reduxjs/toolkit";
import _, { set } from "lodash";
import {
  getDomain,
  postCodigoEnvia,
  postCodigoValida,
  postUsuarioPasswordUpdate,
} from "../../services/userEndpoints";
import httpService from "../../services/httpService";

const DOMAIN = getDomain();

const INITIAL_STATE = {
  pasoActual: 0,
  formData: {
    email: "",
    codigoSeguridad: "",
    nuevaContrasena: "",
    confirmarContrasena: "",
  },
  loading: false,
  error: null,
};

export const userSlice = createSlice({
  name: "userSlice",
  initialState: INITIAL_STATE,
  reducers: {
    setPasoActual: (state, action) => {
      state.pasoActual = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
  },
});

export const enviaCodigo = () => async (dispatch, getState) => {
  const { email } = getState().userReducer.formData;
  dispatch(setLoading(true));
  dispatch(setError(null));
  const url = `${DOMAIN}${postCodigoEnvia()}`;
  const { data } = await httpService.post(url, { email });
  if (data?.success) {
    dispatch(setLoading(false));
    dispatch(setPasoActual(1));
  } else {
    dispatch(setLoading(false));
    dispatch(setError(data?.msg || "Error al enviar el código de seguridad"));
  }
};

export const validaCodigo = () => async (dispatch, getState) => {
  const { email, codigoSeguridad: code } = getState().userReducer.formData;
  dispatch(setLoading(true));
  dispatch(setError(null));
  const url = `${DOMAIN}${postCodigoValida()}`;
  const { data } = await httpService.post(url, { email, code });
  if (data?.success) {
    dispatch(setLoading(false));
    dispatch(setPasoActual(2));
  } else {
    dispatch(setLoading(false));
    dispatch(setError(data?.msg || "Error al validar el código de seguridad"));
  }
};
export const updatePassword = () => async (dispatch, getState) => {
  const {
    email,
    nuevaContrasena: password,
    codigoSeguridad: code,
  } = getState().userReducer.formData;
  dispatch(setLoading(true));
  dispatch(setError(null));
  const url = `${DOMAIN}${postUsuarioPasswordUpdate()}`;
  const { data } = await httpService.post(url, {
    email,
    code,
    password,
  });
  if (data?.success) {
    dispatch(setLoading(false));
  } else {
    dispatch(setLoading(false));
    dispatch(setError(data?.msg || "Error al actualizar la contraseña"));
  }
};

export const { setPasoActual, setLoading, setError, setFormData } =
  userSlice.actions;

export default userSlice.reducer;
